import React from 'react';
import { Container, Group, Text, Anchor, Box } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function SimpleFooter() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      py="xl"
      mt="xl"
      style={{
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e9ecef'
      }}
    >
      <Container size="xl">
        <Group justify="space-between" align="center">
          <Text size="sm" color="dimmed">
            © {currentYear} Sort My Shoebox. All rights reserved.
          </Text>
          
          <Group gap="md">
            <Anchor size="sm" onClick={() => navigate('/terms-and-conditions')} style={{ cursor: 'pointer' }}>
              Terms of Service
            </Anchor>
            <Anchor size="sm" onClick={() => navigate('/privacy-policy')} style={{ cursor: 'pointer' }}>
              Privacy Policy
            </Anchor>
            <Anchor size="sm" onClick={() => navigate('/faq')} style={{ cursor: 'pointer' }}>
              FAQ
            </Anchor>
            <Anchor size="sm" onClick={() => navigate('/blog')} style={{ cursor: 'pointer' }}>
              Blog
            </Anchor>
          </Group>
        </Group>
      </Container>
    </Box>
  );
}
